import { render, staticRenderFns } from "./SectionAboutSig.vue?vue&type=template&id=e66359c2"
import script from "./SectionAboutSig.vue?vue&type=script&lang=js"
export * from "./SectionAboutSig.vue?vue&type=script&lang=js"
import style0 from "./SectionAboutSig.vue?vue&type=style&index=0&id=e66359c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SectionAboutSig.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports